import CONTRATOS from '@/graphql/querys/administracion/contratos/contratos.gql';
import CLIENTES from '@/graphql/querys/administracion/catalogos/clientes/clientes.gql';
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import AGREGAR_CLIENTE from '@/graphql/mutations/administracion/catalogos/clientes/agregarCliente.gql';
import ACTUALIZAR_CLIENTE from '@/graphql/mutations/administracion/catalogos/clientes/actualizarCliente.gql';
import REMOVER_CLIENTE from '@/graphql/mutations/administracion/catalogos/clientes/removerCliente.gql';

export default {
  apollo: {
    clientes: {
      query: CLIENTES,
    },
    contratos: {
      query: CONTRATOS,
    },
    usuarios: {
      query: USUARIOS,
    },
  },
  methods: {
    async mixAgregarCliente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: AGREGAR_CLIENTE,
        variables: {
          nombre: this.cliente.nombre,
          logo: this.cliente.logo,
        },
        update: (store, { data: { agregarCliente } }) => {
          const data = store.readQuery({ query: CLIENTES });
          data.clientes.push(agregarCliente);
          store.writeQuery({ query: CLIENTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarCliente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CLIENTE,
        variables: {
          id: this.clienteEditar.id,
          nombre: this.cliente.nombre,
          logo: this.cliente.logo,
        },
        update: (store, { data: { actualizarCliente } }) => {
          const data = store.readQuery({ query: CLIENTES });
          const { clientes } = data;
          const index = clientes
            .findIndex((cliente) => cliente.id === actualizarCliente.id);
          if (index !== -1) {
            clientes.splice(index, 1, actualizarCliente);
          }
          store.writeQuery({ query: CLIENTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarCliente() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CLIENTE,
        variables: {
          id: this.clienteEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: CLIENTES });
          const { clientes } = data;
          const index = clientes
            .findIndex((cliente) => cliente.id === this.clienteEliminar.id);
          if (index !== -1) {
            clientes.splice(index, 1);
          }
          store.writeQuery({ query: CLIENTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
